"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultipleChoiceQuestion = void 0;

var React = _interopRequireWildcard(require("react"));

var _reactComponents = require("@cimpress/react-components");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const MultipleChoiceQuestion = props => {
  const {
    disabled,
    onChange,
    question
  } = props;
  const {
    style,
    options
  } = question.parameters;
  const {
    value
  } = props;
  let optionsComponent = undefined;

  switch (style) {
    default:
      optionsComponent = /*#__PURE__*/React.createElement(React.Fragment, null, options.map(opt => /*#__PURE__*/React.createElement(_reactComponents.Checkbox, {
        disabled: disabled,
        key: opt.value,
        label: opt.value,
        checked: value === null || value === void 0 ? void 0 : value.includes(opt.value),
        onChange: () => {
          if (value === null || value === void 0 ? void 0 : value.includes(opt.value)) {
            onChange([...(value || []).slice(0, value === null || value === void 0 ? void 0 : value.indexOf(opt.value)), ...(value || []).slice(((value === null || value === void 0 ? void 0 : value.indexOf(opt.value)) || 0) + 1)]);
          } else {
            onChange([...(value || []), opt.value]);
          }
        }
      })));
      break;
  }

  return /*#__PURE__*/React.createElement("div", null, optionsComponent);
};

exports.MultipleChoiceQuestion = MultipleChoiceQuestion;